// extracted by mini-css-extract-plugin
export default {"container":"SimpleBarChart_container__JbeRS"};